import URL_PARAMS from 'components/v2/DataTable/data/urlParams';

import { upperFirst } from 'lodash';

const getGlobalFilterOptionURLParam = (FILTER_NAME: string) =>
  `${URL_PARAMS.globalFilterOption}${upperFirst(FILTER_NAME)}`;

export default getGlobalFilterOptionURLParam;
